<div class="chip-wrapper">

  <!-- Visible Chips -->
  <span *ngFor="let item of visibleSubjects; trackBy: trackByFn"
        class="qld-sub-chip"
        [ngClass]="{
          'chip-capable': item.type === 'capable',
          'chip-qualified': item.type === 'qualified',
          'chip-unknown': item.type === 'unknown'
        }">
    {{ item.label }}
    <div class="tooltip" *ngIf="item.type === 'qualified'">    
      @if(item.yearLevel && item.yearLevel != '0'){Year level: {{ item.yearLevel }},} Sector: {{ item.sector }}
    </div>
  </span>


  <!-- +More -->
  <span *ngIf="remainingCount > 0" class="more-wrapper">

    <span class="more-chip">
      +{{ remainingCount }} more
    </span>

    <!-- Popup -->
    <div class="popup">
      <div class="popup-header">
        {{title}}
      </div>

      <div class="popup-body">
        <span *ngFor="let item of allSubjects; trackBy: trackByFn"
              class="qld-sub-chip"
              [ngClass]="{
                'chip-capable': item.type === 'capable',
                'chip-qualified': item.type === 'qualified',
                'chip-unknown': item.type === 'unknown'
              }">
          {{ item.label }}
          <div class="tooltip" *ngIf="item.type === 'qualified'">    
            @if(item.yearLevel && item.yearLevel != '0'){Year level: {{ item.yearLevel }},} Sector: {{ item.sector }}
          </div>
        </span>
      </div>
    </div>

  </span>

</div>